import { AccessHeader } from './components/accessHeader'
import { ChangeCommunityTypeContainer } from './components/changeCommunityTypeContainer'
import Courses from './components/courses'
import OpenCommunityState from './components/openCommunityState'
import { COMMUNITY_TYPE } from './constants'
import { Container } from './styles'
import type { AccessAndPrivacyProps } from './types'

import useCommunityConfigurationSidebar from '../communityConfigurationSidebar/hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'

const AccessAndPrivacy = ({ isOpen }: AccessAndPrivacyProps) => {
  const { community } = useCommunityConfigurationSidebar()

  return (
    <Container>
      <AccessHeader />
      <ChangeCommunityTypeContainer />

      <div className='_border-bottom' />
      {community.type === COMMUNITY_TYPE.EXCLUSIVE ? (
        <Courses isOpen={isOpen} />
      ) : (
        <OpenCommunityState />
      )}
    </Container>
  )
}

export default AccessAndPrivacy
